export default "__VITE_ASSET__CKyoin37__"